import { Button, Checkbox, CircularProgress, Heading, Icon, IconButton, Input, InputGroup, InputLeftElement, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { BiFile, BiTransfer } from "react-icons/bi";

import { FaArrowLeft, FaArrowRight, FaColumns, FaEdit, FaCloudUploadAlt, FaFilter, FaPlus, FaSearch, FaSync, FaTrash, FaFileDownload } from "react-icons/fa";
import { RiDownload2Fill, RiFileEditFill } from "react-icons/ri";
import { AiFillBank } from "react-icons/ai";
import AddDocument from "../../components/Modals/AddDocument";

export default function BankStatements() {
    const [search, setSearch] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [showFilters, setShowFilters] = useState(false);
    const [selected, setSelected] = useState<Set<string>>(new Set());
    const { isOpen: isUploadOpen, onOpen: onUploadOpen, onClose: onUploadClose } = useDisclosure();

    const toggleSelect = (id: string) => {
        setSelected((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    const [invs] = useState([
        {
            docId: 1,
            docType: "PR",
            name: "Investing 001 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 2,
            docType: "PR",
            name: "Investing 001 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 3,
            docType: "FG",
            name: "Investing 002 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 4,
            docType: "OK",
            name: "EntryBot (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 5,
            docType: "CP",
            name: "Insight Ways Ltd. (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 1,
            docType: "CN",
            name: "Investing 001 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 2,
            docType: "PR",
            name: "Investing 001 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 3,
            docType: "FG",
            name: "Investing 002 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 4,
            docType: "OK",
            name: "EntryBot (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 5,
            docType: "CP",
            name: "Insight Ways Ltd. (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 1,
            docType: "CN",
            name: "Investing 001 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 2,
            docType: "PR",
            name: "Investing 001 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 3,
            docType: "FG",
            name: "Investing 002 (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 4,
            docType: "OK",
            name: "EntryBot (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        },
        {
            docId: 5,
            docType: "CP",
            name: "Insight Ways Ltd. (Processing)",
            invDate: "16-Mar-2022",
            invCurAmt: '8,008.00',
            baseCurAmt: '8,008.00',
            category: 'General Purpose',
            paymentMethod: 'None',
            opening_closing_amount: '8,008.00'
        }
    ]);

    const filteredInvs = useMemo(() => {
        const term = search.trim().toLowerCase();
        return invs.filter((inv: any) => {
            if (filterStatus && inv.docType !== filterStatus) return false;
            if (!term) return true;
            return (
                String(inv.docId).includes(term) ||
                (inv.name ?? '').toLowerCase().includes(term) ||
                (inv.docType ?? '').toLowerCase().includes(term)
            );
        });
    }, [invs, search, filterStatus]);

    const allChecked = filteredInvs.length > 0 && filteredInvs.every((i: any) => selected.has(String(i.docId)));
    const someChecked = filteredInvs.some((i: any) => selected.has(String(i.docId)));

    const toggleAll = () => {
        if (allChecked) {
            setSelected(new Set());
        } else {
            setSelected(new Set(filteredInvs.map((i: any) => String(i.docId))));
        }
    };

    const handleRefresh = () => {
        setSelected(new Set());
    };

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <AddDocument
                isOpen={isUploadOpen}
                onClose={onUploadClose}
                DocType={'Bank Statement'}
                RefreshList={handleRefresh}
            />
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={AiFillBank}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Bank & Card Statements</Heading>
                            <Text fontSize={'sm'}>All bank & card statements</Text>
                        </Stack>
                    </Stack>
                    <Stack
                        direction={'row'}
                    >
                        <Button
                            bg={'gray.200'}
                            color={"primary.900"}
                            px={6}
                            size={'sm'}
                        >
                            All
                        </Button>
                        <Button
                            color={"white"}
                            bg={"primary.600"}
                            _hover={{ bg: 'primary.700' }}
                            _active={{ bg: 'primary.800' }}
                            px={6}
                            size={'sm'}
                        >
                            New
                        </Button>
                        <Button
                            bg={'gray.200'}
                            color={"primary.900"}
                            px={6}
                            size={'sm'}
                        >
                            Processed
                        </Button>
                        <Button
                            bg={'gray.200'}
                            color={"primary.900"}
                            px={6}
                            size={'sm'}
                        >
                            Approved
                        </Button>
                        <Button
                            bg={'gray.200'}
                            color={"primary.900"}
                            px={6}
                            size={'sm'}
                        >
                            Reports
                        </Button>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', "2xl": 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            leftIcon={<FaCloudUploadAlt />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                            onClick={onUploadOpen}
                        >
                            Upload File
                        </Button>
                        <Button
                            leftIcon={<FaPlus />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Add Payment Method
                        </Button>
                        <Button
                            leftIcon={<RiDownload2Fill />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Bulk Download
                        </Button>
                        <Button
                            leftIcon={<RiFileEditFill />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Download Formats
                        </Button>
                        <Button
                            leftIcon={<FaEdit />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Bulk Edit
                        </Button>
                    </Stack>
                    <Stack direction={'row'}>
                        <Button
                            leftIcon={<BiTransfer />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Transfer
                        </Button>
                        <Button
                            leftIcon={<FaFileDownload />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Export
                        </Button>
                        <Button
                            leftIcon={<FaSync />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                            onClick={handleRefresh}
                        >
                            Refresh
                        </Button>
                        <Button
                            leftIcon={<FaColumns />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Columns
                        </Button>
                        <Button
                            leftIcon={<FaFilter />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                            onClick={() => setShowFilters((v) => !v)}
                        >
                            Filter
                        </Button>
                        <Button
                            leftIcon={<FaTrash />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            size={'sm'}
                        >
                            Delete
                        </Button>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Stack direction={{ base: 'column', md: 'row' }} spacing={3} align={{ md: 'center' }}>
                    <InputGroup size={'sm'} maxW={{ md: '320px' }}>
                        <InputLeftElement pointerEvents={'none'} children={<FaSearch color={'gray'} />} />
                        <Input
                            placeholder={'Search statements (ID, name, type)…'}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </InputGroup>
                    {showFilters && (
                        <Select
                            size={'sm'}
                            maxW={{ md: '220px' }}
                            placeholder={'All types'}
                            value={filterStatus}
                            onChange={(e) => setFilterStatus(e.target.value)}
                        >
                            <option value={'PR'}>PR</option>
                            <option value={'FG'}>FG</option>
                            <option value={'OK'}>OK</option>
                            <option value={'CP'}>CP</option>
                            <option value={'CN'}>CN</option>
                        </Select>
                    )}
                    {selected.size > 0 && (
                        <Text fontSize={'sm'} color={'primary.600'}>{selected.size} selected</Text>
                    )}
                </Stack>
                <TableContainer>
                    <Table size='sm'>
                        <Thead
                            zIndex={1}
                            h={'50px'}
                            top={'0%'}
                            bg={'primary.400'}
                            position={'sticky'}
                            alignItems={'flex-start'}
                        >
                            <Tr>
                                <Th color={'white'} width={'40px'}>
                                    <Checkbox
                                        isChecked={allChecked}
                                        isIndeterminate={!allChecked && someChecked}
                                        onChange={toggleAll}
                                        colorScheme={'whiteAlpha'}
                                    />
                                </Th>
                                <Th
                                    color={'white'}
                                    textAlign={'center'}
                                >
                                    Actions
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Doc ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Doc Type
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Display Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Last 4 Digits
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Account Info
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Currency
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Opening / Closing Amount
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Start Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    End Date
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {/* <Tr>
                                <Td as={Stack} spacing={4} direction={'row'} align={'center'} justify={'center'}>
                                    <IconButton
                                        aria-label="Document"
                                        icon={<BiFile />}
                                        color={'green.400'}
                                        bg={'transparent'}
                                        fontSize={'xl'}
                                        rounded={'full'}
                                    />
                                    <CircularProgress isIndeterminate color='primary.400' bg={'transparent'} size={'18px'} />
                                </Td>
                                <Td colSpan={8} textAlign={'center'}>Processing</Td>
                            </Tr> */}
                            {
                                filteredInvs.map((inv: any, idx: number) => (
                                    <Tr key={`${inv.docId}-${idx}`}>
                                        <Td>
                                            <Checkbox
                                                isChecked={selected.has(String(inv.docId))}
                                                onChange={() => toggleSelect(String(inv.docId))}
                                            />
                                        </Td>
                                        <Td as={Stack} spacing={4} direction={'row'} align={'center'} justify={'center'}>
                                            <IconButton
                                                aria-label="Document"
                                                icon={<BiFile />}
                                                color={'green.400'}
                                                bg={'transparent'}
                                                fontSize={'xl'}
                                                rounded={'full'}
                                            />
                                            <CircularProgress isIndeterminate color='primary.400' bg={'transparent'} size={'18px'} />
                                        </Td>
                                        <Td>{inv.docId}</Td>
                                        <Td>{inv.docType}</Td>
                                        <Td>{inv.name}</Td>
                                        <Td>{inv.invDate}</Td>
                                        <Td>{inv.invCurAmt}</Td>
                                        <Td>{inv.baseCurAmt}</Td>
                                        <Td>{inv.opening_closing_amount}</Td>
                                        <Td>{inv.category}</Td>
                                        <Td>{inv.paymentMethod}</Td>

                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}